<template>
  <div class="home">
<Header :title="title"></Header>
<section class="container">
  <body>
  <div class="tile is-ancestor has-text-centered is-12">
    <div class="tile is-parent is-vertical">
      <article class="tile is-child box" @click="redirect('ppc1')">
        <p class="title">👍</p>
        <p class="subtitle">PPC suitability check</p>
      </article>
    </div>
    <div class="tile is-parent">
        <article class="tile is-child box" @click="redirect('ppc2')">
          <p class="title">🚀</p>
          <p class="subtitle">PPC budget tool</p>
        </article>
    </div>
    <div class="tile is-parent">
      <article class="tile is-child box" @click="redirect('seo')">
        <p class="title">💸</p>
        <p class="subtitle">SEO ROI tool</p>
      </article>
    </div>
  </div>
  </body>
</section>

<Footer></Footer>

  </div>
</template>

<script>
// @ is an alias to /src
// import PPC from '@/components/PPC.vue'
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  components: {
    Header,
    Footer
  },
  data () {
    return {
      title: '',
    }
  },
  methods: {
    redirect: function (url) {
      window.location = url;
  }
  }
}
</script>

<style scoped>

.home {
  background-color: #F5F5F5;
  /* font-family: "Averta","Arial","sans-serif" !important; */
}

body, button, input, select, textarea {
    font-family: "Averta","Arial","sans-serif"
}

.body.columns {
  font-family: "Averta","Arial","sans-serif";
}

.tile.tile.is-child:hover {
    cursor: pointer;
}

.container {
  padding-top: 4rem;
  padding-bottom: 22rem;
}

tile.is-ancestor {
  margin-top: 4rem;
}

.tile.is-child {
  /* background-color: #AA354A; */
  background-color: #75BC7F;
}

</style>
